
  var _styles = {
  "ranking-list-title-container": {
    "display": "flex",
    "justifyContent": "center",
    "alignItems": "center",
    "marginTop": "0.32rem",
    "width": "10rem",
    "position": "relative"
  },
  "ranking-list-refresh-text": {
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "textAlign": "center",
    "marginTop": "0.06667rem",
    "marginBottom": "0.13333rem",
    "width": "10rem"
  },
  "ranking-tab-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "width": "10rem",
    "marginTop": "0.26667rem",
    "marginBottom": "0.13333rem"
  },
  "ranking-tab-bg": {
    "width": "9.09333rem",
    "height": "1.06667rem",
    "backgroundColor": "rgb(231,231,231)",
    "borderRadius": "1.06667rem",
    "display": "flex",
    "flexDirection": "row",
    "position": "relative",
    "overflow": "hidden"
  },
  "ranking-tab-item": {
    "flex": 1,
    "height": "1.06667rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center",
    "zIndex": 2
  },
  "ranking-tab-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "color": "rgb(85,85,85)",
    "opacity": 0.7
  },
  "active-text": {
    "color": "rgb(17,17,17)",
    "fontWeight": "600",
    "opacity": 1
  },
  "ranking-tab-slider": {
    "position": "absolute",
    "width": "4.54667rem",
    "height": "0.96rem",
    "backgroundColor": "rgb(255,255,255)",
    "borderRadius": "0.96rem",
    "top": "0.05333rem",
    "zIndex": 1
  },
  "slider-left": {
    "left": "0.05333rem"
  },
  "slider-right": {
    "left": "4.49333rem"
  },
  "top-three-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "flex-end",
    "paddingTop": 0,
    "paddingRight": "0.42667rem",
    "paddingBottom": 0,
    "paddingLeft": "0.42667rem",
    "marginTop": "1.2rem",
    "marginBottom": "0.53333rem"
  },
  "top-three-team-name": {
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "maxWidth": "2.24rem",
    "zIndex": 1,
    "marginTop": "0.85333rem"
  },
  "top-three-call-value": {
    "fontWeight": "400",
    "color": "rgb(0,0,0)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "marginTop": "0.06667rem",
    "zIndex": 1
  },
  "ranking-item-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "height": "2.10667rem",
    "width": "10rem",
    "paddingTop": "0.32rem",
    "paddingRight": "0.49333rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.21333rem"
  },
  "contribution-item-container": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "height": "2.10667rem",
    "width": "10rem",
    "paddingTop": "0.32rem",
    "paddingRight": "0.49333rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.21333rem"
  },
  "ranking-item-number": {
    "color": "rgb(17,17,17)",
    "fontWeight": "700",
    "fontSize": "0.48rem",
    "zIndex": 1,
    "marginRight": "0.32rem",
    "width": "0.96rem",
    "textAlign": "center"
  },
  "ranking-item-team-name": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.37333rem",
    "zIndex": 1,
    "maxWidth": "3.6rem"
  },
  "ranking-item-call-value": {
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "zIndex": 1,
    "width": "2.4rem",
    "textAlign": "left"
  },
  "contribution-call-value": {
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "zIndex": 1,
    "width": "2.66667rem",
    "textAlign": "right"
  },
  "contribution-no-value": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "contribution-no-value-text": {
    "fontWeight": "400",
    "color": "rgb(194,194,194)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "zIndex": 1
  },
  "leader-tag": {
    "position": "absolute",
    "bottom": 0,
    "right": 0,
    "backgroundColor": "rgb(17,17,17)",
    "borderRadius": "0.12rem",
    "paddingTop": "0.08rem",
    "paddingRight": "0.13333rem",
    "paddingBottom": "0.08rem",
    "paddingLeft": "0.13333rem",
    "zIndex": 2
  },
  "leader-tag-text": {
    "color": "rgb(255,255,255)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.26667rem",
    "lineHeight": "0.26667rem"
  },
  "ranking-item-split-line": {
    "width": "6.26667rem",
    "height": "0.01333rem",
    "backgroundColor": "rgb(0,0,0)",
    "opacity": 0.3,
    "position": "absolute",
    "bottom": 0,
    "right": "0.54667rem"
  },
  "ranking-list-no-more-text": {
    "fontWeight": "400",
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem"
  },
  "top-three-item-container": {
    "position": "relative",
    "overflow": "visible"
  }
};



  module.exports = _styles;
  